import HTTP from '../HTTP_GESCOM';

const URL_BASE = 'gescom/DevisCommandeFacture/';

export async function getInfoHavasCalculHonoraire(tiersId) {
  const response = await HTTP.get(URL_BASE + 'GetInfoHavasCalculHonoraireAsync', {
    params: { tiersId: tiersId },
  });
  return response;
}
